import styled from "styled-components";
import Text from "./Text";

const Label = styled(Text).attrs({ as: "label" })`
  font-weight: 500;
  margin: 0.5em 0;
`;

export default Label;
